import * as React from "react"

import {
    Div,
    Header,
} from "@bdfx/fukit"
import Section from "../homepage/section"
import ctrans from "../../common/trans"

const Conditions = () => {
    document.title = ctrans("conditions") + " | Pricing Audit"
return (<Section>
<div>
<Div padding="20px 50px" minHeight={"30vh"}>
    <Header type={1}>{ctrans("conditions")}</Header>
    <Header type={4}>Smluvní ujednání upravující užívání internetové aplikace Pricing Audit</Header>
    <p>
        <ul>
            <li>Aktuální znění podmínek naleznete na <a target="_blank" href={`/pricing/podminky_uzivani.pdf`}>tomto odkazu [PDF]</a></li>
        </ul>
    </p>

</Div>
</div>
</Section>)
}

export default Conditions